var render, staticRenderFns
import script from "./ChartRadar.vue?vue&type=script&lang=js&"
export * from "./ChartRadar.vue?vue&type=script&lang=js&"
import style0 from "./ChartRadar.vue?vue&type=style&index=0&id=02684c48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02684c48",
  null
  
)

component.options.__file = "ChartRadar.vue"
export default component.exports